import SidebarCollapse from "@builder/components/app/SidebarCollapse";
import EditableInfo from "@builder/components/editable/EditableInfo";
import { EditableProps } from "@builder/components/editable/editableProps";
import SelectInput from "@builder/components/general/SelectInput";
import { getSelectedNode } from "@builder/store/slices/BuilderSlice/builderSelectors";
import { updateNodeProperty } from "@builder/store/slices/BuilderSlice/builderSlice";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { EmbedSectionNode } from "@common/build/types";

const EmbedSection = ({ parent }: EditableProps) => {
    const dispatch = useAppDispatch();
    const node = useAppSelector(getSelectedNode) as EmbedSectionNode;

    const embededSection = node.embededSection;
    const embededSectionOptions = {
        orders: "Orders",
        customers: "Customers",
        refunds: "Refunds"
    };
    const embededSectionCallback = (value: string) => {
        dispatch(updateNodeProperty({ propertyPath: ["embededSection"], value }));
    };

    return (
        <SidebarCollapse title="Embed Section" parent={parent}>
            <EditableInfo
                header="What is an embed section?"
                body="Embed sections are pre-made components, like the Customer pane and order management, that are useful for covering basic POS functionality in your build."
            />
            <SelectInput
                title="Choose section to embed"
                layout="column"
                value={embededSection}
                options={embededSectionOptions}
                callback={embededSectionCallback}
            />
        </SidebarCollapse>
    );
};

export default EmbedSection;
